import { render, staticRenderFns } from "./add-guest-form.vue?vue&type=template&id=6ed40fd4&"
import script from "./add-guest-form.vue?vue&type=script&lang=ts&"
export * from "./add-guest-form.vue?vue&type=script&lang=ts&"
import style0 from "./add-guest-form.vue?vue&type=style&index=0&id=6ed40fd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports